// source: pbtypes/gen/scan_planner/optional_expanded_polygon_prism.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = globalThis;

var pbtypes_gen_scan_planner_expanded_polygon_prism_pb = require('../../../pbtypes/gen/scan_planner/expanded_polygon_prism_pb.js');
goog.object.extend(proto, pbtypes_gen_scan_planner_expanded_polygon_prism_pb);
goog.exportSymbol('proto.scan_planner.OptionalExpandedPolygonPrism', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.scan_planner.OptionalExpandedPolygonPrism = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.scan_planner.OptionalExpandedPolygonPrism, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.scan_planner.OptionalExpandedPolygonPrism.displayName = 'proto.scan_planner.OptionalExpandedPolygonPrism';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.scan_planner.OptionalExpandedPolygonPrism.prototype.toObject = function(opt_includeInstance) {
  return proto.scan_planner.OptionalExpandedPolygonPrism.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.scan_planner.OptionalExpandedPolygonPrism} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.scan_planner.OptionalExpandedPolygonPrism.toObject = function(includeInstance, msg) {
  var f, obj = {
enabled: jspb.Message.getBooleanFieldWithDefault(msg, 1, false),
expandedPolygonPrism: (f = msg.getExpandedPolygonPrism()) && pbtypes_gen_scan_planner_expanded_polygon_prism_pb.ExpandedPolygonPrism.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.scan_planner.OptionalExpandedPolygonPrism}
 */
proto.scan_planner.OptionalExpandedPolygonPrism.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.scan_planner.OptionalExpandedPolygonPrism;
  return proto.scan_planner.OptionalExpandedPolygonPrism.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.scan_planner.OptionalExpandedPolygonPrism} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.scan_planner.OptionalExpandedPolygonPrism}
 */
proto.scan_planner.OptionalExpandedPolygonPrism.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setEnabled(value);
      break;
    case 2:
      var value = new pbtypes_gen_scan_planner_expanded_polygon_prism_pb.ExpandedPolygonPrism;
      reader.readMessage(value,pbtypes_gen_scan_planner_expanded_polygon_prism_pb.ExpandedPolygonPrism.deserializeBinaryFromReader);
      msg.setExpandedPolygonPrism(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.scan_planner.OptionalExpandedPolygonPrism.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.scan_planner.OptionalExpandedPolygonPrism.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.scan_planner.OptionalExpandedPolygonPrism} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.scan_planner.OptionalExpandedPolygonPrism.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getEnabled();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
  f = message.getExpandedPolygonPrism();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      pbtypes_gen_scan_planner_expanded_polygon_prism_pb.ExpandedPolygonPrism.serializeBinaryToWriter
    );
  }
};


/**
 * optional bool enabled = 1;
 * @return {boolean}
 */
proto.scan_planner.OptionalExpandedPolygonPrism.prototype.getEnabled = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.scan_planner.OptionalExpandedPolygonPrism} returns this
 */
proto.scan_planner.OptionalExpandedPolygonPrism.prototype.setEnabled = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};


/**
 * optional ExpandedPolygonPrism expanded_polygon_prism = 2;
 * @return {?proto.scan_planner.ExpandedPolygonPrism}
 */
proto.scan_planner.OptionalExpandedPolygonPrism.prototype.getExpandedPolygonPrism = function() {
  return /** @type{?proto.scan_planner.ExpandedPolygonPrism} */ (
    jspb.Message.getWrapperField(this, pbtypes_gen_scan_planner_expanded_polygon_prism_pb.ExpandedPolygonPrism, 2));
};


/**
 * @param {?proto.scan_planner.ExpandedPolygonPrism|undefined} value
 * @return {!proto.scan_planner.OptionalExpandedPolygonPrism} returns this
*/
proto.scan_planner.OptionalExpandedPolygonPrism.prototype.setExpandedPolygonPrism = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.scan_planner.OptionalExpandedPolygonPrism} returns this
 */
proto.scan_planner.OptionalExpandedPolygonPrism.prototype.clearExpandedPolygonPrism = function() {
  return this.setExpandedPolygonPrism(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.scan_planner.OptionalExpandedPolygonPrism.prototype.hasExpandedPolygonPrism = function() {
  return jspb.Message.getField(this, 2) != null;
};


goog.object.extend(exports, proto.scan_planner);
